module.exports = __webpack_public_path__ + "img/customerBanner.803f0263.png";